import { render, staticRenderFns } from "./LoginTemplate.vue?vue&type=template&id=32ed24c2&"
import script from "./LoginTemplate.vue?vue&type=script&lang=js&"
export * from "./LoginTemplate.vue?vue&type=script&lang=js&"
import style0 from "./LoginTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports